export default __webpack_public_path__ + "static/media/check.f5df332d.svg";